<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      :backdrop-variant="variant"
      backdrop
      no-header
      right
      shadow
    >
      <!-- <template #default="{hide}"> -->
      <header class="b-sidebar-header position-fixed">
        <div
          class="d-flex w-100"
          style=" position: fixed;
            background: #f9f9f9;
width: 100; border-bottom: solid 1px #f7efef;"
        >
          <h3 class="ml-3 mt-1" id="sidebar-no-header-title">
            <span style="font-size:21px" class="nt-clock"></span> Activity Log
          </h3>
        </div>
      </header>
      <div
        class="py-2 h-90 mt-3 overflow-auto logs-container"
        v-if="audit.length > 0"
      >
        <div class="px-2 py-2 mt-4">
          <div class="card card-style" v-for="(i, index) in audit" :key="index">
            <div class="card-body p-2">
              <h5>Action: {{ i.action }}</h5>
              <h5>Action Type : {{ i.actionType }}</h5>
              <h6>Done By :{{ i.performedByName }}</h6>
              <h6>Done At : {{ getTime(i.performedOn) }}</h6>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-100 d-flex justify-content-center align-items-center h-10"
        v-if="audit.length > 0"
      >
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage">
          <template #first-text>
            <b-icon icon="skip-start-fill"></b-icon>
          </template>
          <template #last-text>
            <b-icon icon="skip-end-fill"></b-icon>
          </template>
          <template #next-text>
            <b-icon icon="caret-right-fill"></b-icon>
          </template>
          <template #prev-text>
            <b-icon icon="caret-left-fill"></b-icon>
          </template>
        </b-pagination>
      </div>
      <div
        class="w-100 h-100 d-flex justify-content-center align-items-center"
        v-if="audit.length < 1"
      >
        <h4>Data not available</h4>
      </div>
      <!-- </template> -->
    </b-sidebar>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import { formatAMPMTime, formatTime } from "@/utils/date-helpers";
import { BSidebar } from "bootstrap-vue";

export default {
  components: {
    BSidebar,
  },
  props: {
    audit: Array,
    currentPage: {
      default: 1,
      type: Number,
    },
    totalRows: {
      default: 10,
      type: Number,
    },
    perPage: {
      default: 4,
      type: Number,
    },
  },
  methods: {
    getTime: function(value) {
      if (value) {
        let date;
        if (value.charAt(value.length - 1) === "Z") {
          date = value;
        } else {
          date = value + "Z";
        }
        let val = this.isTimeformat
          ? formatTime(new Date(date))
          : formatAMPMTime(new Date(date));
        return val;
      }
      return "";
    },
  },
  data: function() {
    return {
      variant: "light",
    };
  },
  watch: {
    currentPage: function(newVal) {
      this.$emit("changeCurrentPage", newVal);
    },
  },
};
</script>

<style scoped>
.card-style {
  width: 100%;
  background: white;
  color: #6e6c68;
  min-height: 100px;
  padding: 10px;
  margin-bottom: 10px;
}
.rd-item {
  border-radius: 4px;
  padding: 7px 8px;
  background-color: #fff;
  margin-right: 5px;
  color: #004085;
  font-size: 12px;
  line-height: 1;
}
span.rd-badge {
  padding: 0px 5px;
  background: #0047b2;
  border-radius: 5px;
  color: #ffffff;
  line-height: 1;
  font-size: 11px;
  margin-left: 4px;
}
.h-90 {
  height: 90% !important;
}
.h-10 {
  height: 10% !important;
  overflow-y: wrap !important;
}
::v-deep .b-sidebar-body {
  overflow-y: unset !important;
}
.b-sidebar-header {
  z-index: 100;
}
::v-deep .logs-container::-webkit-scrollbar {
  width: 0px !important;
}
.bg-page {
  background-color: #0047b2 !important;
}
::v-deep .page-item.active .page-link {
  background-color: #0047b2 !important;
  border-color: #0047b2 !important;
  color: white !important;
  font-weight: bold !important;
}
::v-deep .page-link {
  color: #0047b2 !important;
  font-weight: bold !important;
}
</style>
